import React from 'react';
import './LoadingSpinner.css';

/**
 * 加载动画组件
 * @param {string} size - 尺寸: 'small' | 'medium' | 'large'
 * @param {string} message - 可选的加载提示文字
 */
const LoadingSpinner = ({ size = 'medium', message = '' }) => {
  return (
    <div className={`loading-spinner-container ${size}`}>
      <div className="spinner"></div>
      {message && <p className="loading-message">{message}</p>}
    </div>
  );
};

export default LoadingSpinner;
